/**
 * Created by mac on 11/3/25
 */

const LightningRushMerge3Adapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("energy")) {
            return;
        }

        cleverapps.eventBus.on("spendEnergy", (amount) => {
            if (!MissionManager.hasProperLocation(Mission.TYPE_LIGHTNING_RUSH)) {
                return;
            }

            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);

            if (mission && mission.logic.isActiveState()) {
                mission.logic.earnPoints(amount);
            }
        });

        cleverapps.missionManager.on("lightningRushStart", (mission) => {
            if (mission.getType() === Mission.TYPE_LIGHTNING_RUSH) {
                mission.logic.startCompetition();
            }
        });
    }
};

cleverapps.whenAllInitialized(() => LightningRushMerge3Adapter.SubscribeToEvents());